const e = {
  A: {
    color: "#6251A5",
    value: "A - Ultra Wealthy Families",
    categoricalLookup: ["A - Ultra Wealthy Families"],
    visible: !0
  },
  B: {
    color: "#9E5278",
    value: "B - Wealthy Suburban Families",
    categoricalLookup: ["B - Wealthy Suburban Families"],
    visible: !0
  },
  C: {
    color: "#8A7FC1",
    value: "C - Upper Suburban Diverse Families",
    categoricalLookup: ["C - Upper Suburban Diverse Families"],
    visible: !0
  },
  D: {
    color: "#185393",
    value: "D - Suburban Boomers",
    categoricalLookup: ["D - Suburban Boomers"],
    visible: !0
  },
  E: {
    color: "#1058CA",
    value: "E - Near-Urban Diverse Families",
    categoricalLookup: ["E - Near-Urban Diverse Families"],
    visible: !0
  },
  F: {
    color: "#407AD7",
    value: "F - Blue Collar Suburbs",
    categoricalLookup: ["F - Blue Collar Suburbs"],
    visible: !0
  },
  G: {
    color: "#C02400",
    value: "G - Educated Urbanites",
    categoricalLookup: ["G - Educated Urbanites"],
    visible: !0
  },
  H: {
    color: "#DF943D",
    value: "H - Young Professionals",
    categoricalLookup: ["H - Young Professionals"],
    visible: !0
  },
  I: {
    color: "#EDC23B",
    value: "I - Young Urban Singles",
    categoricalLookup: ["I - Young Urban Singles"],
    visible: !0
  },
  J: {
    color: "#D66D66",
    value: "J - Sunset Boomers",
    categoricalLookup: ["J - Sunset Boomers"],
    visible: !0
  },
  K: {
    color: "#9D2901",
    value: "K - Budget Boomers",
    categoricalLookup: ["K - Budget Boomers"],
    visible: !0
  },
  L: {
    color: "#457422",
    value: "L - Rural High Income",
    categoricalLookup: ["L - Rural High Income"],
    visible: !0
  },
  M: {
    color: "#75A552",
    value: "M - Rural Average Income",
    categoricalLookup: ["M - Rural Average Income"],
    visible: !0
  },
  N: {
    color: "#9CC280",
    value: "N - Rural Resilience",
    categoricalLookup: ["N - Rural Resilience", "N - Rural Low Income"],
    visible: !0
  },
  O: {
    color: "#7D600A",
    value: "O - Small Town",
    categoricalLookup: ["O - Small Town", "O - Small Town Low Income"],
    visible: !0
  },
  P: {
    color: "#BC9114",
    value: "P - Melting Pot Families",
    categoricalLookup: ["P - Melting Pot Families", "P - Lower Hispanic Families"],
    visible: !0
  },
  Q: {
    color: "#999999",
    value: "Q - City Hopefuls",
    categoricalLookup: ["Q - City Hopefuls", "Q - Urban Low Income"],
    visible: !0
  }
}, o = Object.values(e);
export {
  o as PERSONA_LIVE_BINS,
  e as PERSONA_LIVE_BIN_MAP
};
//# sourceMappingURL=index.es92.js.map
